export const useStyles = (theme) => ({
  paper: {
    padding: 10,
    display: "flex",
  },
});
